import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    title: 'Guía Digital El Protocolo de los 15 Minutos',
    desc: 'El paso a paso para sincronizar el reloj de tu bebé hoy mismo.'
  }, {
    title: 'El Método de los 3 Toques',
    desc: 'Cómo calmar su llanto de protesta sin tener que sacarlo de la cuna.'
  }, {
    title: 'Escala de Somnolencia Visual',
    desc: "El truco de las 'cejas rosadas' para no fallar nunca en la hora de acostarlo."
  }, {
    title: 'Checklist de Auditoría de Habitación',
    desc: 'Los 4 factores ambientales que eliminan los despertares por distracción.'
  }, {
    title: 'Rastreador de Ventanas de 7 Días',
    desc: 'Plantilla para mapear el ritmo único de tu hijo.'
  }];
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-189">
      <FadeIn data-id="element-190">
        <h2 className="text-3xl sm:text-4xl text-center text-taupe mb-10" data-id="element-191">
          ¿Qué incluye el Protocolo?
        </h2>
      </FadeIn>

      <div className="space-y-6" data-id="element-192">
        {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-193">
            <div className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-sage/10" data-id="element-194">
              <CheckCircleIcon className="w-6 h-6 text-sage shrink-0 mt-1" data-id="element-195" />
              <div data-id="element-196">
                <h3 className="font-serif text-xl text-taupe mb-1" data-id="element-197">
                  {item.title}
                </h3>
                <p className="text-taupe/70" data-id="element-198">{item.desc}</p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}